import React from 'react';
import { InsuranceSelector } from '../InsuranceSelector/InsuranceSelector';

function InsuranceCard({
    insurances,
    selectedInsurance,
    insuranceDisabled,
    loadInsurances,
    isLoading,
    divideAmountBy,
    onInsuranceChange,
}) {
    return (
        <section className='FormCard'>
            <div className='SectionHeader'>
                <div>
                    <h2>Seguro</h2>
                </div>
            </div>

            <div className='InsuranceWrapper'>
                <InsuranceSelector
                    options={insurances}
                    selected={selectedInsurance}
                    onChange={onInsuranceChange}
                    disabled={insuranceDisabled}
                    loadFunction={loadInsurances}
                    loading={isLoading}
                    divideAmountBy={divideAmountBy}
                />
            </div>
        </section>
    );
}

export { InsuranceCard };
